import React, { Component } from 'react';
import { message } from '@cloud/atom-ui';
import './input.less';
import Input from '../text-line-input'

export default class InputSum extends Component {
  state = {
    status: false,
    clientSecret: '***************'
  }
  disPlay = () => {
    this.props.disPlay?.(!this.state.status);
    this.setState({
      status: !this.state.status
    })
  }
  copySecretEvent = () => {
    let copy_value = document.getElementById('inputValue').innerHTML
    const input = document.createElement('input')
    document.body.appendChild(input)
    input.setAttribute('value', copy_value)
    input.select()
    if (document.execCommand('copy')) {
      message.success('复制成功！')
    } else {
      message.warning('复制失败!')
    }
    // 删除'虚拟'DOM
    document.body.removeChild(input)
  }
  getTextByStatus = status => {
    return status ? '隐藏' : '显示';
  }

  render() {
    const { status, clientSecret } = this.state
    const { item, change, resetSecret, isRole, copySecret } = this.props;
    const { isEdit, value, maxlength, className = '' } = item;
    let value1 = item.value || '';
    const readOnly = className === 'onlyReady' ? 'readonly' : '';
    const valueShow = !item.isReset ? value :
      <ValueSpan staus={status} value={value} clientSecret={clientSecret}></ValueSpan>;
    return (<div className="common-input">
      {isEdit
        ? <Input hwClass={item.isShowError ? 'input' : className ? className : ''}
          readOnly={readOnly}
          style={{ window: '600px' }}
          maxLength={maxlength}
          placeholder={item.placeholder || ''}
          defaultValue={value1}
          value={value1}
          onChange={(event) => change(event.target.value || '')} />
        : <div className="description">
          {valueShow}
          {item.isShow && item.isReset && <><span
            onClick={() => this.disPlay(status)}>{this.getTextByStatus(status)}</span>{isRole &&
              <span onClick={resetSecret}>重置</span>}
            {isRole && <span onClick={() => this.copySecretEvent()}>一键复制</span>} </>}
        </div>
      }

    </div>)
  }
}

function ValueSpan({ staus, value, clientSecret }) {
  return staus ? (
    <span className="values">
      <span style={{ marginLeft: '0' }}>{value}</span>
      <span style={{ marginLeft: '0' }} id='inputValue'>{value}</span>
    </span>
  ) : (
    <span className="values">
      <span style={{ marginLeft: '0' }} id='inputValue'>{value}</span>
      <span style={{ marginLeft: '0' }}>{clientSecret}</span>
    </span>
  );
}
